<template>
  <div ref="tooltip" class="tooltip" :style="style">{{ profile.noc }}: {{ profile.unitGroup }}</div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    profile: Object,
    position: {
      type: Object,
      default: {
        top: 99999,
        left: 99999
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style: {}
    };
  },
  watch: {
    position: {
      deep: true,
      handler: function() {
        this.$set(this.style, "left", this.position.x + "px");
        this.$set(this.style, "top", this.position.y + "px");
      }
    }
  },
  mounted() {}
};
</script>

<style scoped>
.tooltip {
  position: fixed;
  background-color: black;
  color: white;
  padding: 5px;
  border-radius: 10px;
  border-style: solid;
  border-width: 1px;
  font-size: 1.3em;
}
</style>